/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：637
 */

var r = require(/* 246 */"../1782/246/index")
var o = require(/* 577 */"../1648/577")
var i = require(/* 300 */"../1648/300/index")
var a = r("unscopables")
var /* [auto-meaningful-name] */Array$prototype = Array.prototype
if (undefined == Array$prototype[a]) {
  i.f(Array$prototype, a, {
    configurable: true,
    value: o(null)
  })
}
module.exports = function (e) {
  Array$prototype[a][e] = true
}
